@if (!!message && showError) {
  <div class="flex flex-row py-3 mb-3 card-width" [ngClass]="severity + '-style'">
    <div class="ml-3">
      @if (severity === 'warning') {
        <span class="pi pi-exclamation-triangle"></span>
      }
      @if (severity === 'error') {
        <span class="pi pi-info-circle"></span>
      }
    </div>
    <div class="ml-3 w-full" [ngClass]="clickable ? 'cursor-pointer' : ''" (click)="clickEvent.emit($event)">
      <div class="font-bold">{{ 'person.dashboard.' + severity | translate }}: {{ date() | shortDate }}</div>
      <div class="message mt-2">{{ message }}</div>
    </div>
    @if (closeable) {
      <div class="mx-3">
        <i class="pi pi-times cursor-pointer" (click)="showError = false; closeEvent.emit();"></i>
      </div>
    }
  </div>
}
